import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHospitalPrevention } from 'infrastructure/hooks/control-panel';
import PatientControlButton from 'components/atoms/patentControlButton';
import HospitalPreventionFormModal from 'components/organisms/controlPanel/hospitalPrevention/formModal';
import ControlHospitalizationIcon from 'components/atoms/icons/controlHospitalizationIcon';
import { useAccess } from 'infrastructure/hooks/access/useAccess';

import { useGetClinicEscalationValues } from '../hooks/useGetClinicEscalationValues';

import type { ModuleType } from 'infrastructure/enums';

interface IProps {
  module: ModuleType;
  patientGuid: string;
  clinicGuid?: string;
}

const HospitalEscalationsControls: React.FC<IProps> = (props) => {
  const { module, patientGuid, clinicGuid } = props;
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  const {
    isCombinedModule,
    isCcmActionDisabled,
    isReadOnlyRole,
    isBlockRpmModule,
  } = useAccess({
    module,
    patientGuid,
  });

  const { defaultHospitalPreventionValues, loading } =
    useGetClinicEscalationValues({ patientGuid });

  const { sendHospitalPrevention, sendHospitalPreventionLoading } =
    useHospitalPrevention({
      onSuccess() {
        setOpen(false);
      },
    });

  const disabled = isCombinedModule
    ? isReadOnlyRole || isBlockRpmModule
    : isCcmActionDisabled;

  return (
    <>
      <PatientControlButton
        label={t('labels.hospitalizationPrevention')}
        Icon={ControlHospitalizationIcon}
        loading={sendHospitalPreventionLoading || loading}
        disabled={disabled}
        handleClick={() => setOpen(true)}
      />

      {open && (
        <HospitalPreventionFormModal
          isOpen={open}
          closeModal={() => setOpen(false)}
          onSubmit={sendHospitalPrevention}
          defaultValue={defaultHospitalPreventionValues}
          submitLoading={sendHospitalPreventionLoading}
          clinicGuid={clinicGuid}
        />
      )}
    </>
  );
};

export default HospitalEscalationsControls;
